module.exports = __webpack_public_path__ + "media/gameover.ad511c5b.mp4";